// extracted by mini-css-extract-plugin
export default {"verifyContainer":"Reset_verifyContainer__0yJwf","title":"Reset_title__KNqv6","message":"Reset_message__t8zse","checkIcon":"Reset_checkIcon__pdqnW"};